import React from 'react';
import SvgIcon from '@client/components/shared/svgIcon/SvgIcon';

export function Close(props) {
    return (
        <SvgIcon {...props}>
            <path d="M.677 0l15.32 15.32-.677.678L0 .678z" fill="currentColor" />
            <path d="M15.322 0L16 .675.68 15.996 0 15.32z" fill="currentColor" />
        </SvgIcon>
    );
}

Close.defaultProps = {
    viewBox: '0 0 16 15.999'
};

export default Close;
